var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"add-button",style:(_vm.styleObj),attrs:{"type":"dashed"}},[_c('svg-icon',{attrs:{"icon-class":"plus"}}),_c('span',[_vm._v(_vm._s(_vm.addText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }